export const AutotextDynamicTypes = {
    text: 'text',
    link: 'link',
    linkDynamicLabel: 'linkDynamicLabel',
};
